import { useState } from "react";
import { useCommunicationBinding } from "./useCommunicationBinding";
import useThridPartyCommunicationChannel from "./useThirdPartyCommunicationChannel";
import EmailAddressBinding from "./EmailAddress/EmailAddressBinding";

export default function EmailCommunicationBinding(props) {
  const {
    communicationBinding,
    syncAssistant,
    assistantId,
    workspaceId,
    assistantType,
    locked,
  } = props;

  const { addCommunicationBinding, removeCommunicationBinding } =
    useCommunicationBinding({
      syncAssistant,
      assistantId,
      workspaceId,
      assistantType,
    });

  const { communicationChannel } = useThridPartyCommunicationChannel({
    workspaceId,
  });

  const { emailAddresses, emailProvider } = communicationChannel;

  const [openDelete, setOpenDelete] = useState({
    item: null,
    isOpen: false,
  });

  const handleBindingDelete = () => {
    removeCommunicationBinding(openDelete.item._id).then(() => {
      setOpenDelete({ item: null, isOpen: false });
    });
  };

  const handleBindingAdd = (data, closeDialog) => {
    const payload = {
      channelType: assistantType,
      isActive: true,
      ...data,
      metadata: {
        emailProvider,
      },
    };
    addCommunicationBinding(payload).then(closeDialog);
  };

  return (
    <EmailAddressBinding
      isOpen={openDelete.isOpen}
      onClose={() => setOpenDelete({ isOpen: false, item: null })}
      onBindingDelete={(item) => setOpenDelete({ isOpen: true, item })}
      onBindingAdd={handleBindingAdd}
      onBindingConfirmDelete={handleBindingDelete}
      emailAddresses={emailAddresses}
      communicationBinding={communicationBinding}
      locked={locked}
    />
  );
}
